import React from "react";
import "./projects.css";
import MissIndiaCafeImg from "../../assets/images/miss-india-cafe.svg";
import BloggzImg from "../../assets/images/bloggz.svg";
import PremioImg from "../../assets/images/premio.svg";
import Tilt from "react-parallax-tilt";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

// TODO: add border with offset to the project images
const Projects = () => {
  const projectSectionAnimation = {
    hidden: {
      opacity: 0,
      y: 100,
    },

    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: "easeOut",
        staggerChildren: 0.35,
      },
    },

    exit: {
      opacity: 0,
      y: 100,
      transition: {
        duration: 1,
        ease: "easeOut",
      },
    },
  };
  return (
    <section className="projects">
      <Container>
        <motion.h1
          initial="hidden"
          whileInView="animate"
          exit="exit"
          variants={projectSectionAnimation}
        >
          Projects
        </motion.h1>
        <motion.p
          initial="hidden"
          whileInView="animate"
          exit="exit"
          variants={projectSectionAnimation}
        >
          Welcome to my projects section! Here you can find some of the exciting
          and challenging projects that I have completed. Each project showcases
          my skills in various aspects of web development, including front-end
          design, back-end programming, database management, and more.
          <br />
          <br />I am always eager to take on new projects, so feel free to
          contact me if you would like to work together!
        </motion.p>
        <br />
        <div id="project-1" className="project-card">
          <motion.div
            className="project-info-copy"
            initial="hidden"
            whileInView="animate"
            exit="exit"
            variants={projectSectionAnimation}
          >
            <span id="project-number">01.</span>
            <h2>
              <a
                href="https://www.behance.net/gallery/156552809/Miss-India-Cafe-UIUX-Design"
                target="_blank"
                rel="noopener noreferrer"
              >
                Miss India Cafe
              </a>
            </h2>
            <p>UIUX Design of food delivery app for the cafe business</p>
            <span className="tech-pill">UIUX Design</span>
          </motion.div>
          <Tilt>
            <Link
              to={
                "https://www.behance.net/gallery/156552809/Miss-India-Cafe-UIUX-Design"
              }
            >
              <motion.img
                initial="hidden"
                whileInView="animate"
                exit="exit"
                src={MissIndiaCafeImg}
                alt=""
              />
            </Link>
          </Tilt>
        </div>

        <div id="project-2" className="project-card">
          <motion.div
            className="project-info-copy"
            initial="hidden"
            whileInView="animate"
            exit="exit"
            variants={projectSectionAnimation}
          >
            <span id="project-number">02.</span>
            <h2>
              <a
                href="https://github.com/rehan-ankalgi-7t2/bloggz-v2"
                target="_blank"
                rel="noopener noreferrer"
              >
                Bloggz
              </a>
            </h2>
            <p>Fullstack Blog Website in Neubrutalism Design</p>
            <span className="tech-pill">Fullstack Web Development</span>
            <span className="tech-pill">UIUX Design</span>
            <span className="tech-pill">MERN Stack</span>
          </motion.div>
          <Tilt>
            <Link to={"https://github.com/rehan-ankalgi-7t2/bloggz-v2"}>
              <motion.img
                initial="hidden"
                whileInView="animate"
                exit="exit"
                variants={projectSectionAnimation}
                src={BloggzImg}
                alt=""
              />
            </Link>
          </Tilt>
        </div>

        <div id="project-3" className="project-card">
          <motion.div
            className="project-info-copy"
            initial="hidden"
            whileInView="animate"
            exit="exit"
            variants={projectSectionAnimation}
          >
            <span id="project-number">03.</span>
            <h2>
              <a href="https://github.com/rehan-ankalgi-7t2/RealEstate-website">
                Premio
              </a>
            </h2>
            <p>Landing page design for real estate business</p>
            <span className="tech-pill">Web Design & Development</span>
            <span className="tech-pill">Static Website</span>
            <span className="tech-pill">UIUX Design</span>
          </motion.div>
          <Tilt>
            <Link
              to={"https://github.com/rehan-ankalgi-7t2/RealEstate-website"}
            >
              <motion.img
                initial="hidden"
                whileInView="animate"
                exit="exit"
                variants={projectSectionAnimation}
                src={PremioImg}
                alt=""
              />
            </Link>
          </Tilt>
        </div>
      </Container>
    </section>
  );
};

export default Projects;
